<template>
    <div class="datepickerwrap p-0 mt-0" id="asins-compare">
        <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
            <!-- <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div> -->
            <Loader />
        </div>
        <div class="">
            <div class="card d-flex justify-content-between flex-row mt-3 align-items-center">
                <div style="margin: 0; padding-bottom: 0 !important" class="graphHeading">
                    <!-- Listing Quality Score (LQS) Analysis -->
                    Asins Compare
                </div>
                <router-link to="/lqs-analyser" style="text-decoration: none; float: right">
                    <button style="width: max-content; float: right" class="btn navigationButton" type="button">
                        <i class="fa fa-arrow-left"></i>
                        <span style="font-size: 13px"> Back</span>
                    </button>
                </router-link>
            </div>
            <!-- <div v-if="storeASINsCompareData.length == 0" class="card text-center no-data-asin text-danger">No
                comparison data</div> -->

            <div v-if="!compareShowDataKey && loader" class="onLoadingData">Loading...</div>
            <div v-else-if="!compareShowDataKey && !loader"
                class="text-danger d-flex justify-content-center border border-danger rounded mt-1 p-2 noData">
                No comparison data.
            </div>
            <div v-else class="compare-container-data bg-white p-4 rounded">
                <div class="card">
                    <div class="d-flex">
                        <div class="col-sm-4 px-0 fixed-position point-compare pb-0">
                            <h2 class="bgTopColor mb-0"></h2>
                            <div class="product-image points-highlighted border-bottom d-flex align-items-center pl-4"
                                style="height: 20.8rem;">
                                Product Description
                            </div>
                            <!-- <p class="product-name"></p> -->
                            <div class="quality-score border-bottom points-highlighted d-flex align-items-center pl-4">
                                <!-- Quality Score -->
                                Listing Quality Score
                            </div>
                            <div class="border-bottom">
                                <div class="copy-breakdown points-highlighted pl-4">Copy Breakdown</div>
                                <div class="space-between-header pt-1"
                                    v-for="(row, i) in storeASINsCompareData[0].lqs_analysis.copy_breakdown"
                                    :key="'lqs_cb' + i" :class="plotStrip(i)">
                                    <div class="" style="text-transform: capitalize">
                                        {{ row.label }}
                                        <!-- <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                            :title="row.label"></i> -->
                                    </div>
                                </div>
                            </div>

                            <div class="border-bottom">
                                <div class="media-breakdown points-highlighted pl-4">Media Breakdown</div>
                                <div class="space-between-header pt-1"
                                    v-for="(row, i) in storeASINsCompareData[0].lqs_analysis.media_breakdown"
                                    :key="'lqs_cb' + i" :class="plotStrip(i)">
                                    <div class="" style="text-transform: capitalize">
                                        {{ row.label }}
                                        <!-- <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                            :title="row.label"></i> -->
                                    </div>
                                </div>
                            </div>

                            <div class="border-bottom">
                                <div class="review-breakdown points-highlighted pl-4">Review Breakdown</div>
                                <div class="space-between-header pt-1"
                                    v-for="(row, i) in storeASINsCompareData[0].lqs_analysis.review_breakdown"
                                    :key="'lqs_cb' + i" :class="plotStrip(i)">
                                    <div class="" style="text-transform: capitalize">
                                        {{ row.label }}
                                        <!-- <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                            :title="row.label"></i> -->
                                    </div>
                                </div>
                            </div>
                            <div style="height: 50px;"></div>
                        </div>
                        <div class="">
                            <div class="col-sm-8 ml-0 pl-0 d-flex position-absolute asin-compare-card pr-0">
                                <div class="col-6 pl-0 pr-0" v-for="(data, i) of storeASINsCompareData">
                                    <div class="bgTopColor d-flex justify-content-center align-items-center"
                                        style="color: #5E5E5E">Product {{
                                            i + 1 }}</div>
                                    <product-card-compare :asinData="data.asin" :viewLqsListingdata="data.lqs_analysis"
                                        :viewLqsGraph="data.total" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '../Components/Loader.vue';
import ProductCardCompare from './ProductCardCompare.vue';
import { mapState, mapActions } from "vuex";

export default {
    name: "ASINsComapre",
    components: { ProductCardCompare, Loader },
    data: function () {
        return {
            loader: true,
            storeCompareASINs: JSON.parse(this.$route.params.compareASINs),
            storeASINsCompareData: [],
            gaugeChartData: {},
            compareShowDataKey: false
        };
    },
    mounted() {
        this.dataAPIs()
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    },
    methods: {
        ...mapActions("DemoStore", [
            "setSelectedLanguage",
            "initializeTranslation",
        ]),
        dataAPIs() {
            this.getASINsCompareData()
        },

        plotStrip(i) {
            let idx = i + 1;
            if (idx % 2 == 0) {

                return 'bgHighlight';
            }
            else {

                return 'bgMuted'
            }
        },
        goBack() {
            window.history.back();
        },
        getASINsCompareData() {
            let self = this;
            self.loader = true;
            let payload = {
                asin_id: this.storeCompareASINs,
                language: this.$store.state.DemoStore.selectedLanguage.key,
            };
            const url = "/api/v2/spider/comparelqs";
            self.$http
                .post(url, payload)
                .then((response) => {
                    // console.log(response.body.data.data)
                    this.compareShowDataKey = response.body.data_present
                    this.storeASINsCompareData = response.body.data.data;
                    self.loader = false;
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },

    },
}
</script>

<style scoped>
.bgHighlight {
    color: "#000";
    padding-left: 1.5rem;
    /* background: #efefef; */
    background-color: #fcfcfc;
    border-bottom: 1px solid #fff !important;
}

.bgMuted {
    color: "#000";
    padding-left: 1.5rem;
    /* background: #f6f6f6; */
    background-color: #fcfcfc;
    border-bottom: 1px solid #fff !important;
}

.asin-compare-card {
    overflow: auto;
}

.navigationButton {
    height: 35px;
    border: none;
    margin: 0;
    background: var(--accent_color);
    color: #fff;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 700;
    padding: 0 20px;
    letter-spacing: .2px;
    font-family: poppins;
}

.card {
    border-radius: .7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.compare-container-data .card {
    border: 1px solid #EBEBEB !important;
    padding: 0rem !important;
    /* overflow: hidden !important; */
    margin-bottom: 0 !important;
}

.no-data-asin {
    font-size: 18px;
}

.point-compare {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    z-index: 1;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.quality-score {
    height: 15.05rem !important
}


.points-highlighted {
    font-size: 18px;
    font-weight: semibold;
    padding: 14px 0 12px;
}

.textColor {
    color: #818890 !important;
}

.compare-container-data {
    width: 100%;
    margin: 0 auto;
    border-radius: .7rem !important;
}

.space-between-header {
    margin-bottom: 0px !important;
}

.asin-compare-card>div:last-child {
    padding-right: 0 !important;
}

.review-breakdown {
    padding: 11px 0;
}

.copy-breakdown {
    background-color: #0096881A;
}

.media-breakdown {
    background-color: #6956E51A;
}

.review-breakdown {
    background-color: #FD55421A;
}

.bgTopColor {
    background-color: #0655590D;
    height: 40px;
    border: 3px !important;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 18px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}
</style>
